import React from "react";
import "./Trigger.css";
import useInfo from "../../hooks/use-info";

const Trigger = () => {
  // setup ----------------------------------------------------------------------
  const { bar, srvy, exp } = useInfo();

  // renderfunc ----------------------------------------------------------------------
  const renderTrig = () => {
    if (bar === 4 && srvy && exp !== 1) {
      return (
        <div className="trig_cont">
          {"실태조사할 도로링크를 최소 1개 선택하세요"}
        </div>
      );
    }
    return null;
  };

  // return ----------------------------------------------------------------------
  return renderTrig();
};

export default Trigger;
